import * as swcHelpers from '@swc/helpers';
import { getProductType } from './get-shopping-list-product-type.js';

const mapShoppingListToWishlistItems = (shoppingList)=>{
    if (shoppingList) {
        if (shoppingList.__typename === 'AddToShoppinglistSuccessResponse' || shoppingList.__typename === 'RemoveFromShoppinglistSuccessResponse') {
            return shoppingList.result.items.map((item)=>{
                var ref, ref1, ref2, ref3, ref4;
                const shoppinglistItem = {
                    sku: item.sku,
                    name: item.name,
                    // TODO: Add the slug and grab it from the product property in the AddToShoppinglistFragment and RemoveFromShoppinglistFragment
                    slug: '',
                    productType: getProductType(item.variant.__typename),
                    imageSrc: (ref = item.variant.media.images[0]) === null || ref === void 0 ? void 0 : ref.url,
                    originalPrice: (ref1 = item.variant.prices.originalPrice) === null || ref1 === void 0 ? void 0 : ref1.amount,
                    discountedPrice: (ref2 = item.variant.prices.discountedPrice) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.price) === null || ref3 === void 0 ? void 0 : ref3.amount,
                    currencyCode: (ref4 = item.variant.prices.originalPrice) === null || ref4 === void 0 ? void 0 : ref4.currencyCode
                };
                return shoppinglistItem;
            });
        } else if (shoppingList.__typename === 'Shoppinglist') {
            /*
        NOTE: This mapping is still relevant until the BE moves to the new shopping list response format
        which returns a variant instead of a product type, removing the need to search for the matching variant.
        This will be done in https://jira.grandvision.global/browse/MACC-16022. Until then we need to
        keep this code for mutations and queries to support the old/current shopping list response format.
      */ return shoppingList === null || shoppingList === void 0 ? void 0 : shoppingList.items.map((item)=>{
                let additionalFields = {};
                switch(item.product.__typename){
                    case 'AccessoriesProduct':
                    case 'ContactLensProduct':
                    case 'FrameProduct':
                    case 'LensTypeProduct':
                    case 'PrescriptionGlassesPackageOptionsProduct':
                    case 'PrescriptionGlassesPackageProduct':
                    case 'ReadyReaderProduct':
                    case 'SolutionProduct':
                    case 'SunglassesProduct':
                        const matchingVariantIndex = item.product.variants.findIndex((variant)=>{
                            return variant.sku === item.sku;
                        });
                        const matchingVariant = item.product.variants[matchingVariantIndex];
                        if (matchingVariant) {
                            var ref, ref5, ref6, ref7, ref8;
                            additionalFields = {
                                imageSrc: (ref = matchingVariant.media.images[0]) === null || ref === void 0 ? void 0 : ref.url,
                                originalPrice: (ref5 = matchingVariant.prices.originalPrice) === null || ref5 === void 0 ? void 0 : ref5.amount,
                                discountedPrice: (ref6 = matchingVariant.prices.discountedPrice) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.price) === null || ref7 === void 0 ? void 0 : ref7.amount,
                                currencyCode: (ref8 = matchingVariant.prices.originalPrice) === null || ref8 === void 0 ? void 0 : ref8.currencyCode
                            };
                        }
                        break;
                    default:
                        additionalFields = {};
                        break;
                }
                const shoppinglistItem = swcHelpers.objectSpread({
                    sku: item.sku,
                    name: item.name,
                    productType: getProductType(item.product.__typename),
                    slug: item.product.slug
                }, additionalFields);
                return shoppinglistItem;
            });
        }
    }
    return [];
};

export { mapShoppingListToWishlistItems };
//# sourceMappingURL=shopping-list-to-wishlist-mapper.js.map
